import {CtModelRouteData} from "@ctsolution/ct-framework";

export const TaskRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("task");